const getApiBaseUrl = () => {
  if (window.location.hostname === 'chat.acceptancegroup.org') {
    return 'https://api.acceptancegroup.org';
  }
  return 'https://api.screwltd.com';
};

export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${endpoint}`;
};

export default getApiBaseUrl; 